import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

import { pages } from '@/settings/pages';

type Props = {
  children?: never;
  isManager: boolean;
};

export const InvitationLink: React.FC<Props> = (props) => {
  const { isManager } = props;
  const { t } = useTranslation();

  if (!isManager) {
    return null;
  }

  return (
    <Styled>
      <Link to={pages.membership.invite} data-test="invite-link">
        <Icon name="add user" />
        {t('ui.action.inviteManager')}
      </Link>
    </Styled>
  );
};

const Styled = styled.div`
  margin: -3.3em 0 2em 0;
  text-align: right;
`;
